import type { UserSession } from 'types';

function parseDobCandidate(
  value: Date | string | null | undefined,
): Date | null {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;
    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  return null;
}

/**
 * Resolve a stored date of birth from the session (flat `dob` or `background.birthday`).
 * Returns a valid Date, or null when missing/invalid. Never invents "today".
 */
export default function resolveUserDob(
  user: Pick<UserSession, 'dob' | 'background'>,
): Date | null {
  const candidates: Array<Date | string | null | undefined> = [
    user.dob,
    user.background?.birthday,
  ];

  const parsed = candidates
    .map(candidate => parseDobCandidate(candidate))
    .find((d): d is Date => d != null);

  return parsed ?? null;
}
